import { initializeLDProvider } from '@omnipresentgroup/launchdarkly';

import { environment } from '../environment';

export const WrappedLaunchDarkly = await initializeLDProvider({
  clientId: environment.launchDarkly.CLIENT_SIDE_ID,
});
